export enum PlanAction{
    SelectPlan = "Select Plan",
    Confirmation = "Confirm Plan"
}